import { selectedItemsForSyncContext } from ".";

export const SelectedItemsForSyncProvider = selectedItemsForSyncContext.Provider;